import type { AuthResponse, AuthTokenRequest } from '@core/interfaces/auth.interface';

import { mockDb } from '../mock-db';

const VALID_CREDENTIALS: {
  externalCodeName: string;
  username: string;
  password: string;
}[] = [
  {
    externalCodeName: 'mojacardream',
    username: 'admin@mojacardream.com',
    password: 'mock-only-password',
  },
];

/**
 * Validate login credentials and return auth tokens
 * Supports both plain email and hostId/email formats
 */
export function loginMock(request: AuthTokenRequest): AuthResponse | null {
  const match = VALID_CREDENTIALS.find(cred => {
    const usernameMatch =
      request.username === cred.username || request.username === `host-001/${cred.username}`;
    return (
      request.externalCodeName === cred.externalCodeName &&
      usernameMatch &&
      request.password === cred.password
    );
  });

  if (match) {
    return {
      accessToken: 'mock-access-token-12345',
      refreshToken: 'mock-refresh-token-67890',
    };
  }
  return null;
}

export function refreshTokenMock(): AuthResponse {
  return {
    accessToken: 'mock-new-access-token-12345',
    refreshToken: 'mock-new-refresh-token-67890',
  };
}

export function getHostByCodeMock(externalCodeName: string): { name: string } | null {
  return mockDb.getHostNameByCode(externalCodeName);
}
